import React, { useState } from "react";
import { autoUpdate, offset, shift } from "@floating-ui/dom";
import { useFloating } from "@floating-ui/react";
import { ReactComponent as InfoIcon } from "../../../images/info.svg";

interface TooltipProps {
  tooltips: string[];
}

const Tooltip: React.FC<TooltipProps> = ({ tooltips }) => {
  const { refs, floatingStyles } = useFloating({
    placement: "top",
    whileElementsMounted: autoUpdate,
    middleware: [offset(10), shift({ padding: 10 })],
  });
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div
        ref={refs.setReference}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        style={{ display: "inline-block", cursor: "pointer" }}
      >
        <InfoIcon className="terminal-insights-tooltip__info-icon" />
      </div>
      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          className="terminal-insights-tooltip"
        >
          <div className="terminal-insights-tooltip__content">
            {tooltips.map((tooltip, index) => (
              <div key={index}>{tooltip}</div>
            ))}
          </div>
          <div className="terminal-insights-tooltip__tail"></div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
